import React from 'react';

function RichText(props) {
  const { richText } = props;

  return <div className="RichText" dangerouslySetInnerHTML={{ __html: richText }} />;
}

export default RichText;
